import {
  resolveFeedbackTemplateLocale,
  type FeedbackTemplateLocale,
} from '@up2stay/up2promo-commons/feedback';
import type { Workspace } from '@up2stay/up2promo-api-client';

/**
 * Read the workspace default language used for Feedback catalog resolution.
 */
export function readWorkspaceFeedbackLocale(
  workspace: Workspace | null | undefined,
): string | null {
  if (!workspace?.defaultLocale) return null;
  return workspace.defaultLocale;
}

export function resolveAppFeedbackCatalogLocale(input: {
  workspace: Workspace | null | undefined;
  userLocale: string;
}): FeedbackTemplateLocale {
  return resolveFeedbackTemplateLocale({
    workspaceLocale: readWorkspaceFeedbackLocale(input.workspace),
    userLocale: input.userLocale,
  });
}

export const FEEDBACK_LIBRARY_PICKER_DEFAULT_LOCALE: FeedbackTemplateLocale =
  'de';

export function resolveFeedbackLibraryPickerLocale(
  override: FeedbackTemplateLocale | null,
): FeedbackTemplateLocale {
  return override ?? FEEDBACK_LIBRARY_PICKER_DEFAULT_LOCALE;
}
